import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';

@Component({
    selector: 'app-insurance-success',
    standalone: true,
    imports: [HeaderComponent, FooterComponent, CommonModule],
    templateUrl: './insurance-success.component.html',
    styleUrl: './insurance-success.component.scss',
})
export class InsuranceSuccessComponent {
    selectedLanguage: any;
    source: string | null = null;
    contentBase = {
        title: 'Form successfully submitted!',
        titleBm: 'Borang berjaya dihantar!',
        btn: 'Back to Homepage',
        btnBm: 'Ke Halaman Utama',
        desc: (company: string) =>
            `Your form has been submitted to ${company}. You will be contacted within 3 working days.`,
        descBm: (company: string) =>
            `Borang anda telah dihantar ke ${company}. Anda akan dihubungi dalam masa 3 hari bekerja.`,
    };

    companyNames = {
        liberty: 'Liberty',
        'project-insurance': 'Liberty',
        'policy-street': 'Policy Street',
    };

    currentContent: any;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
        this.route.queryParams.subscribe((params) => {
            const source = params['source'] || 'policy-street'; // default
            const company = this.companyNames[source] || source.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase());

            this.currentContent = {
                title: this.contentBase.title,
                titleBm: this.contentBase.titleBm,
                desc: this.contentBase.desc(company),
                descBm: this.contentBase.descBm(company),
                btn: this.contentBase.btn,
                btnBm: this.contentBase.btnBm,
            };
        });
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }
}